import { RouteConfig } from 'vue-router';

import RouterView from '@/components/appLayout/Router.vue';
import { documentEPUAPSubmitRoute } from './documentEPUAPSubmit.route';
import { epuapSignFaliureRoute } from './epuapSignFaliure.route';
import { epuapSignSuccessRoute } from './epuapSignSucces.route';

export const epuapRoute: RouteConfig = {
  path: 'epuap',
  component: RouterView,
  children: [documentEPUAPSubmitRoute, epuapSignSuccessRoute, epuapSignFaliureRoute]
};
